import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { sanitizeRanges } from './syntaxRangeProvider.js';
export var ID_INIT_PROVIDER = 'init';
export var InitializingRangeProvider = /*#__PURE__*/function () {
  function InitializingRangeProvider(editorModel, initialRanges, onTimeout, timeoutTime) {
    _classCallCheck(this, InitializingRangeProvider);

    this.editorModel = editorModel;
    this.id = ID_INIT_PROVIDER;

    if (initialRanges.length) {
      var toDecorationRange = function toDecorationRange(range) {
        return {
          range: {
            startLineNumber: range.startLineNumber,
            startColumn: 0,
            endLineNumber: range.endLineNumber,
            endColumn: editorModel.getLineLength(range.endLineNumber)
          },
          options: {
            stickiness: 1
            /* NeverGrowsWhenTypingAtEdges */

          }
        };
      };

      this.decorationIds = editorModel.deltaDecorations([], initialRanges.map(toDecorationRange));
      this.timeout = setTimeout(onTimeout, timeoutTime);
    }
  }

  _createClass(InitializingRangeProvider, [{
    key: "dispose",
    value: function dispose() {
      if (this.decorationIds) {
        this.editorModel.deltaDecorations(this.decorationIds, []);
        this.decorationIds = undefined;
      }

      if (typeof this.timeout === 'number') {
        clearTimeout(this.timeout);
        this.timeout = undefined;
      }
    }
  }, {
    key: "compute",
    value: function compute(cancelationToken) {
      var foldingRangeData = [];

      if (this.decorationIds) {
        var _iterator = _createForOfIteratorHelper(this.decorationIds),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var id = _step.value;
            var range = this.editorModel.getDecorationRange(id);

            if (range) {
              foldingRangeData.push({
                start: range.startLineNumber,
                end: range.endLineNumber,
                rank: 1
              });
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }

      return Promise.resolve(sanitizeRanges(foldingRangeData, Number.MAX_VALUE));
    }
  }]);

  return InitializingRangeProvider;
}();